<style type="text/css">
.test-query-input .field-input {
  padding: 0px 10px;
  font-size: 13px;
  line-height: 1.42857143;
  background-color: #fff;
  background-image: none;
  border-color: transparent;
  border-radius: 0;
  -webkit-box-shadow: inset 0 0 0 transparent;
  box-shadow: inset 0 0 0 transparent;
  -webkit-transition: border-color ease-in-out .15s, -webkit-box-shadow ease-in-out .15s;
  -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  transition: border-color ease-in-out;
  border: 0 !important;
  border-bottom: 1px solid #e7eff3 !important;
  height: 35px;
  font-weight: 500;
  width: 100%;
  color: #253858;
}

.test-query-input .field-input:focus {
  outline: none;
  border: 0 !important;
}

</style>
<template>
  <div class="row"
       v-if="field.name != 'created_at' && field.name != 'updated_at' && field.name != 'visibility' && field.field_type != 'autonumber'">
    <div class="col-md-3 d-flex align-items-center justify-content-end">
      <div class="test-map-fields">{{ field.label }}
        <sup class="text text-danger" v-if="field.is_required">*</sup>
      </div>
    </div>
    <div class="col-md-7 d-flex align-items-center">
      <!-- dropdown -->
      <div v-if="field.field_type == 'select'" class="item-detail">
        <select class="table-item-detail-select" :id="field.name" v-model="getValue">
          <option :ref="field.name" :value="data" v-for="data in field.select_values"> {{ data }}
          </option>
        </select>
      </div>
      <!-- Relationship -->
      <div v-else-if="field.field_type == 'relationship'">
        <div v-if="field.name == 'created_by' || field.name == 'modified_by' || field.name == 'assigned_to'"
             class="item-detail">
          <select class="table-item-detail-select" :id="field.name" v-model="getValue">
            <option :ref="field.name" :value="user.id" v-for="user in SelectedTable.user_name"> {{ user.name }}
            </option>
          </select>
        </div>
        <div v-else class="item-detail">
          <select class="table-item-detail-select" :id="field.name" v-model="getValue">
            <option :ref="field.name" :value="related_id" v-for="(related_value,related_id) in field.related_fields">
              {{ related_value }}
            </option>
          </select>
        </div>
      </div>
      <!-- Radio Button -->
      <div v-else-if="field.field_type == 'radio'">
					<span v-for="(data,index) in field.select_values" :key="index">
						<input type="radio" :checked="index == 0 ? 'checked' : false" :value="data" :class="field.name"
                   :name="field.name" v-model="getValue" :ref="field.name" :id="field.name"
                   class="test-query-field">{{ data }}
					</span>
      </div>
      <!-- Phone Number -->
      <div v-else-if="field.field_type == 'phone'">
        <input type="number" v-model="getValue" :ref="field.name" :id="field.name" class="test-query-field">
      </div>
      <!-- Email Id -->
      <div v-else-if="field.field_type == 'email'">
        <input type="email" v-model="getValue" :ref="field.name" :id="field.name" class="test-query-field">
      </div>
      <!-- TextArea -->
      <div v-else-if="field.field_type == 'multiline'">
        <textarea :ref="field.name" v-model="getValue" :id="field.name" class="test-query-field"></textarea>
      </div>
      <div v-else-if="field.field_type == 'multiselect' || field.field_type == 'multipleselect'" class="item-detail">
        <div class="row">
          <div v-for="data in field.select_values" class="col-12 text-left">
            <input type="checkbox" :name="field.name+'['+getIndexForCheckBox(field, data)+']'"
                   @click="CheckBoxClicked($event, field, data)" :value="data"
                   :checked="IsCheckBoxChecked(field, data)"> {{ data }}
          </div>
        </div>
      </div>
      <div v-else-if="field.name == 'multi_assigned_to'" class="item-detail">
        <div class="row">
          <div v-for="user in SelectedTable.user_name" class="col-12 text-left">
            <input type="checkbox" :name="field.name+'['+user.id+']'"
                   @click="CheckBoxClicked($event, field, user)" :value="user.id"
                   :checked="IsCheckBoxChecked(field, user)"> {{ user.name }}
          </div>
        </div>
      </div>
      <div v-else-if="field.field_type == 'checkbox'">
        <div class="row">
          <div class="col-12 text-left">
            <input type="checkbox" :id="field.name" @click="isChecked(field.name)" :name="field.name"
                   v-model="getValue">
          </div>
        </div>
      </div>
      <div v-else-if="field.name == 'company_id'" class="item-detail">
        <select class="table-item-detail-select" :id="field.name">
          <option :ref="field.name" v-model="getValue" :value="company_id"
                  v-for="(companyName,company_id) in companies"> {{ companyName }}
          </option>
        </select>
      </div>
      <div v-else-if="field.name == 'visibility'" class="item-detail">
        <select class="table-item-detail-select" :id="field.name" v-model="getValue">
          <option :ref="field.name" v-model="getValue" :value="id" v-for="(visibility,id) in visibilities">
            {{ visibility }}
          </option>
        </select>
      </div>
      <!-- Text -->
      <div v-else>
        <div v-if="field.name == 'created_by' || field.name == 'modified_by' || field.name == 'assigned_to'"
             class="item-detail">
          <select class="table-item-detail-select" :id="field.name" v-model="getValue">
            <option :ref="field.name" :value="user.id" v-for="user in SelectedTable.user_name"> {{ user.name }}
            </option>
          </select>
        </div>
        <div v-else-if="field.type == 'date' || field.type == 'datetime'">
          <div class="position-relative test-query-input">
            <VueCtkDateTimePicker
                v-if="field.type == 'date'"
                :format="setDynamicFormat()"
                :formatted="setDynamicFormat()"
                v-model="getValue"
                :no-label="true"
                :noClearButton="true"
                label=""
                :locale="lang.code"
                :button-now-translation="lang.now"
                :only-date="true"
                :position="'bottom'"
            />
            <VueCtkDateTimePicker
                v-else
                :format="setDynamicFormat()+' HH:mm'"
                :formatted="setDynamicFormat()+' HH:mm'"
                v-model="getValue"
                :no-label="true"
                :noClearButton="true"
                :locale="lang.code"
                :button-now-translation="lang.now"
                label=""
                :position="'bottom'"
            />
          </div>
        </div>
        <div v-else>
          <input type="text" v-model="getValue" :ref="field.name" :id="field.name" class="test-query-field">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    'SelectedTable',
    'companies',
    'field',
    'simulationFormData',
    'Auth',
    'lang',
  ],
  data() {
    return {
      visibilities: {
        1: 'Everyone',
        0: 'Private',
      },
      checkbox_data: [],
    }
  },
  mounted() {
    // console.log(this.Auth);
  },
  computed: {
    getValue: {
      get() {
        return this.getMappedValue();
      },
      set(newVal) {
        return this.setMappedValue(newVal);
      }
    }
  },
  created() {
    // console.log(this.Auth.formatting);
  },
  methods: {
    setDynamicFormat() {
      switch (this.Auth.formatting.date_order) {
        case 'd-m-Y':
          return this.setDateSeparator('DD-MM-YYYY');
          break;
        case 'm-d-Y':
          return this.setDateSeparator('MM-DD-YYYY');
          break;
        case 'Y-m-d' :
          return this.setDateSeparator('YYYY-MM-DD');
          break;
        case 'Y-d-m' :
          return this.setDateSeparator('YYYY-DD-MM');
          break;
        default :
          return this.setDateSeparator('DD-MM-YYYY');
      }
    },
    setMappedValue(val) {
      let data = {
        'name': this.field.name,
        'value': val,
      };
      this.$emit('simulationFormDataEvent', data);
      return val;
    },
    setDateSeparator(format) {
      if (this.Auth.formatting.date_separator) {
        let _separator = this.Auth.formatting.date_separator;
        return format.replace(/-/g, _separator);
      } else {
        return format;
      }
    },
    getMappedValue() {
      let fieldValue = null;
      let _index = this.simulationFormData.findIndex(x => x.name == this.field.name);

      if (_index > -1) {
        if (this.field.field_type == 'checkbox') {
          fieldValue = this.simulationFormData[_index].value == 'off' ? null : this.simulationFormData[_index].value;
        } else {
          fieldValue = this.simulationFormData[_index].value;
        }
      }
      return fieldValue;
    },
    getIndexForCheckBox(field, value) {
      for (let i = 0; i < field.select_values.length; i++) {
        if (field['select_values'][i] == value) {
          return i;
        }
      }

      return null;
    },
    CheckBoxClicked(event, field, data) {
      if (this.checkbox_data[field.id] == undefined) {
        this.checkbox_data[field.id] = [];
      }

      if (data != null) {
        if (event.target.checked) {
          this.checkbox_data[field.id].push(data);
        } else {
          // pop the value
          let i = this.checkbox_data[field.id].indexOf(data);

          this.checkbox_data[field.id].splice(i, 1);
        }

        // set the data in simulation form data
        let _index = this.simulationFormData.findIndex(x => x.name == field.name);

        if (_index > -1) {
          this.simulationFormData[_index].value = this.checkbox_data[field.id];
        }
      }

    },
    IsCheckBoxChecked(field, data) {
      if (this.checkbox_data[field.id] != undefined) {
        for (let i = 0; i < this.checkbox_data[field.id].length; i++) {
          if (this.checkbox_data[field.id][i] == data) {
            return true;
          }
        }
      }

      let _index = this.simulationFormData.findIndex(x => x.name == field.name);
      if(field.name === 'multi_assigned_to'){
        let value = this.simulationFormData[_index].value;
        if(value !== null && value.length){
          value = JSON.parse(value);
          let option_value = data.id.toString();
          if(value.includes(option_value)){
            return true;
          }
        }
      }
      if (this.simulationFormData[_index].value != null && _index > -1) {
        let _i = this.simulationFormData[_index].value.indexOf(data);
        if (_i > -1) {
          return true;
        }
      }

      return false;
    },
    isChecked(field_name) {

      let _index = this.simulationFormData.findIndex(x => x.name == field_name);

      if (_index > -1) {
        if (document.getElementById(field_name).checked == false) {
          this.simulationFormData[_index].value = 'off';
        }
      }
    }
  }
}
</script>
